import { EntrepreneurAnnounce7FormContainer} from "../../../containers/SupportSystem/SupportForm/EntrepreneurAnnounce7FormContainer";
export function EntrepreneurAnnounce7FormPage() {
    return (
        <EntrepreneurAnnounce7FormContainer />
    );

}